import script from "./BulkPurchaseList.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkPurchaseList.vue?vue&type=script&setup=true&lang=js"

export default script